// Restores the compact Vitals rating summary in the product heading.
const PLACEHOLDER_SELECTOR = '#vital_reviews_under_title';
const SCHEMA_SELECTOR = '#vtlsAebReviewsSchemaJson';
let repairTimer;

function readAggregateRating() {
  const schema = document.querySelector(SCHEMA_SELECTOR);

  if (!schema?.textContent) return null;

  try {
    const data = JSON.parse(schema.textContent);
    const aggregate = data?.aggregateRating;
    const rating = Number.parseFloat(aggregate?.ratingValue);
    const count = Number.parseInt(aggregate?.reviewCount ?? aggregate?.ratingCount, 10);

    if (!Number.isFinite(rating) || !Number.isFinite(count) || count < 1) return null;

    return {
      rating: Math.min(5, Math.max(0, rating)),
      count,
    };
  } catch {
    return null;
  }
}

function makeStarMeter(rating) {
  const meter = document.createElement('span');
  const empty = document.createElement('span');
  const filled = document.createElement('span');

  meter.className = 'gkikz-product-rating__stars';
  meter.setAttribute('aria-hidden', 'true');
  empty.className = 'gkikz-product-rating__stars-empty';
  filled.className = 'gkikz-product-rating__stars-filled';
  empty.textContent = '★★★★★';
  filled.textContent = '★★★★★';
  filled.style.width = `${(rating / 5) * 100}%`;
  meter.append(empty, filled);

  return meter;
}

function renderRating() {
  const placeholder = document.querySelector(PLACEHOLDER_SELECTOR);
  const aggregate = readAggregateRating();

  if (!placeholder || !aggregate) return false;

  const appBlock = placeholder.closest('.shopify-app-block');
  const headingRow = document.querySelector('.gk-product-heading-row');
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
  const desktopHeading = appBlock
    ?.closest('.gk-pdp-rail__heading')
    ?.querySelector(':scope > .group-block-content');
  const host = isDesktop ? desktopHeading : headingRow?.parentElement;

  if (!appBlock || !host || (!isDesktop && !headingRow)) return false;
  if (host.querySelector(':scope > .gkikz-product-rating')) return true;

  const roundedRating = aggregate.rating.toFixed(1);
  const reviewLabel = `${aggregate.count} ${aggregate.count === 1 ? 'review' : 'reviews'}`;
  const link = document.createElement('button');
  const score = document.createElement('span');
  const count = document.createElement('span');

  link.type = 'button';
  link.className = 'gkikz-product-rating';
  link.setAttribute(
    'aria-label',
    `Rated ${roundedRating} out of 5 from ${reviewLabel}. Jump to customer reviews.`
  );

  score.className = 'gkikz-product-rating__score';
  score.textContent = roundedRating;
  count.className = 'gkikz-product-rating__count';
  count.textContent = reviewLabel;

  link.append(makeStarMeter(aggregate.rating), score, count);
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const reviews = document.querySelector('#bundle-product_reviews');

    if (!reviews) return;

    if (window.matchMedia('(min-width: 1024px)').matches) {
      document.documentElement.classList.add('gkikz-reviews-scroll');
      document.body.classList.add('gkikz-reviews-scroll');
    }

    const scrollToReviews = (behavior) => {
      const headerOffset =
        document.querySelector('#header-component')?.offsetHeight ??
        document.querySelector('#header-group')?.offsetHeight ??
        document.querySelector('header')?.offsetHeight ??
        0;
      const pageWrapper = document.querySelector('.page-wrapper');
      const scrollTarget =
        window.matchMedia('(min-width: 1024px)').matches &&
        pageWrapper?.scrollHeight > pageWrapper?.clientHeight
          ? pageWrapper
          : window;
      const currentScroll =
        scrollTarget === window ? window.scrollY : scrollTarget.scrollTop;
      const top =
        reviews.getBoundingClientRect().top + currentScroll - headerOffset - 12;

      scrollTarget.scrollTo({ top, behavior });
    };

    window.setTimeout(() => scrollToReviews('smooth'), 40);
    window.setTimeout(() => scrollToReviews('auto'), 450);
  });

  appBlock.classList.add('gkikz-rating-source-block');
  if (isDesktop) {
    desktopHeading.insertBefore(link, appBlock.parentElement?.parentElement);
  } else {
    headingRow.insertAdjacentElement('afterend', link);
  }

  return true;
}

function initializeRating(attempt = 0) {
  if (renderRating() || attempt >= 12) return;
  window.setTimeout(() => initializeRating(attempt + 1), 250);
}

function scheduleRating() {
  initializeRating();

  // The product layout rebuilds its visible heading while Vitals finishes loading.
  window.clearInterval(repairTimer);
  let checks = 0;
  repairTimer = window.setInterval(() => {
    renderRating();
    checks += 1;

    if (checks >= 24) window.clearInterval(repairTimer);
  }, 750);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleRating, { once: true });
} else {
  scheduleRating();
}

document.addEventListener('shopify:section:load', scheduleRating);
